const SetupAssistantConfig = {
  endpoints: {
    getContentPillars: "/setup/assistant/getcontentpillars"
  }
};

export { SetupAssistantConfig };
